import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import SearchResults from '../Components/SearchResults/SearchResults'
import { useLocation } from 'react-router-dom'
function SearchPage() {
  return (
    <>
    <Combaintop/>
    <SearchResults/>
    <Combainbottom/>
    </>
  )
}

export default SearchPage;
